import { HotelReservedCardPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card.types";
import { useIsVisible } from "@website/hooks/is-visible";
import { isFilled } from "@website/utils/is-filled";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";

export const useHotelReserveCard = (
  properties: HotelReservedCardPropertiesType
) => {
  const {
    id,
    bookNeedConfirm,
    hotelId,
    provider,
    promotion,
    bookType,
    title,
    availableRooms,
    extraBed,
    hasBreakfast,
    facilities,
    price,
    img,
    adults,
    isLoading,
    nightCount,
    minStay,
    priceOff,
    rackIncluded,
    description,
    onClick: onHandleClick,
    roomRacks,
    hasMorContentButton,
    freeCancellation,
    cancellationPolicies,
    regularBadges,
    hotelType,
    roomDetail,
    onInView,
    snappPayData,
    notifyData,
    hasSnappProDiscount
  } = properties;

  const router = useRouter();
  const [roomCount, setRoomCount] = useState(
    Number.isNaN(Number(router.query["no_rooms"]))
      ? 1
      : Number(router.query["no_rooms"]) <= availableRooms
        ? Number(router.query["no_rooms"])
        : availableRooms
  );

  useEffect(() => {
    setRoomCount(
      Number.isNaN(Number(router.query["no_rooms"]))
        ? 1
        : Number(router.query["no_rooms"]) <= availableRooms
          ? Number(router.query["no_rooms"])
          : availableRooms === 0
            ? 1
            : availableRooms
    );
  }, [roomDetail?.showRoomDetail, router?.query?.["no_rooms"]]);

  const [openPackageModal, setOpenPackageModal] = useState(false);

  const onClose = useCallback(() => setOpenPackageModal(false), []);

  const { reference, inView } = useIsVisible();

  useEffect(() => {
    onInView?.(inView);
  }, [inView, onInView]);

  const onRacksClick = useCallback(() => {
    setOpenPackageModal(isFilled(roomRacks));
  }, [roomRacks]);

  return {
    roomRacks,
    openPackageModal,
    onClose,
    hotelReserveCardContentProps: {
      id,
      title,
      availableRooms,
      extraBed,
      hasBreakfast,
      facilities,
      img,
      adults,
      onClick: roomDetail?.handleShowRoomDetail,
      description,
      hasMorContentButton,
      freeCancellation,
      cancellationPolicies,
      regularBadges,
      rackIncluded,
      roomCount
    },
    hotelReserveCardFooterProps: {
      id,
      title,
      bookNeedConfirm,
      hotelId,
      provider,
      promotion,
      bookType,
      availableRooms,
      minStay,
      price,
      isLoading,
      onClick: onHandleClick,
      nightCount,
      priceOff,
      rackIncluded,
      roomRacks,
      onRacksClick,
      adults,
      hotelType,
      snappPayData,
      roomDetail,
      roomCount,
      setRoomCount,
      hasSnappProDiscount
    },
    hotelReserveCardFullCapacityProps: {
      id,
      onClick: roomDetail?.handleShowRoomDetail,
      notifyData,
      roomCount
    },
    hotelReserveCardRacksProps: {
      open: openPackageModal,
      onClose,
      roomRacks,
      title,
      roomDetail: {
        id,
        availableRooms,
        onClick: roomDetail?.handleShowRoomDetail
      }
    },
    reference
  };
};
